import {
  createComponentExtension,
  createPlugin,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const sonarqubeWrapperPlugin = createPlugin({
  id: 'sonarqube-wrapper',
  routes: {
    root: rootRouteRef,
  },
});

export const EntitySonarqubeContent = sonarqubeWrapperPlugin.provide(
  createComponentExtension({
    name: 'SonarqubeContentPage',
    component: {
      lazy: () =>
        import('./components/SonarQubeContentPage').then(
          m => m.SonarQubeContentPage,
        ),
    },
  }),
);
